import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import StyledLink from './StyledLink'
import TimelineEventTitle from './TImelineEventTitle'
import TimelineEventBody from './TimelineEventBody'
import TimelineEventCard from './TimelineEventCard'





const Link = styled(StyledLink)({
  fontWeight: 600
})

const TimelineEventTeamCreated = (props) => {
  const {timelineEvent: timelineEventRef} = props
  const timelineEvent = useFragment(
    graphql`
      fragment TimelineEventTeamCreated_timelineEvent on TimelineEventTeamCreated {
        ...TimelineEventCard_timelineEvent
        id
        team {
          id
          isArchived
          name
        }
      }
    `,
    timelineEventRef
  )
  const {team} = timelineEvent
  const {id: teamId, name: teamName, isArchived} = team
  return (
    React.createElement(TimelineEventCard, {
      iconName: "group_add",
      timelineEvent: timelineEvent,
      title: React.createElement(TimelineEventTitle, null, `You created ${teamName}`),}

      , React.createElement(TimelineEventBody, null
        , isArchived ? (
          'But now it is archived. What a wild ride!'
        ) : (
          React.createElement(React.Fragment, null
            , 'Visit your '
            , React.createElement(Link, { to: `/team/${teamId}/tasks`,}, "team dashboard" )
          )
        )
      )
    )
  )
}

export default TimelineEventTeamCreated
